export default "__VITE_ASSET__B3$peR4G__"